import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer, useRelationshipInjector, useDetailConfigOverrider } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'opportunities/proposal';
const model = 'opportunities/proposal';
const modelExposedName = 'Proposal';
const wizardAction = 'create';

const Create = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { injectToDetail } = useRelationshipInjector();
    const { overrideDetailFields } = useDetailConfigOverrider();
    // DATA PROVIDER
    const { doAction, item, loadOne, loadAll, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName
    const detailConfig = (params.detailConfigOverride) ? overrideDetailFields(existingModules[dataProviderName].detailConfig, params.detailConfigOverride) : existingModules[dataProviderName].detailConfig;
    useEffect(() => {
        loadOne(params.filters?._id);
    }, []);

    const [editing, setEditing] = useState(false)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = async (data) => {
        doAction && doAction({ action: wizardAction, model: model ? model : dataProviderName, data: data });
    }

    injectToDetail(item?.data, 'legalEntity', params.legalEntity);
    injectToDetail(item?.data, 'employment', params.employment);
    injectToDetail(item?.data, 'registered_at', new Date().toISOString());
    injectToDetail(item?.data, 'propertyID', 'W-');
    injectToDetail(item?.data, 'status', 'in_progress');
    injectToDetail(item?.data, 'product', 'buy');
    injectToDetail(item?.data, 'requestValue', '');
    injectToDetail(item?.data, 'offerValue', '');
    injectToDetail(item?.data, 'deltaValue', '');
    injectToDetail(item?.data, 'deltaPercentage', '');
    injectToDetail(item?.data, 'finalValue', '');
    injectToDetail(item?.data, 'buyerName', '');
    injectToDetail(item?.data, 'buyerNationality', '');
    // injectToDetail(item?.data, 'buyerCommissionValue', '');
    injectToDetail(item?.data, 'buyerCommissionPercentage', '');
    injectToDetail(item?.data, 'buyerAgents', null);
    injectToDetail(item?.data, 'sellerName', '');
    injectToDetail(item?.data, 'sellerNationality', '');
    // injectToDetail(item?.data, 'sellerCommissionValue', '');
    injectToDetail(item?.data, 'sellerCommissionPercentage', '');
    injectToDetail(item?.data, 'sellerAgents', null);
    

    return <>
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{ ...item?.data }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t('Newf {{itemname}}', { itemname: t(modelExposedName) })}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.create']}
            header={
                <InfoHeader
                    view="wizard"
                    title={t('Create newf {{itemname}}', { itemname: t(modelExposedName) })}
                    subtitle={t('Fill the basic information to create a newf {{itemname}} that you will be able to edit via the standard interface', { itemname: t(modelExposedName) })}
                />
            }
            {...params}
        />
    </>
}

export default Create;


